import PatientOverview from 'dashboard/templates/views/Patient/Overview/PatientOverview';

export default {
  path: '',
  component: PatientOverview,
  props: true,
  name: 'PatientRecordOverview',
  meta: {
    // title: 'Patient Overview',
    title: 'patient.patientOverview',
    loggedInOnly: true,
    inSDMSessionOnly: true,
  },
};
